export default function Hero() {
  const scrollToAnchor = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-primary-100/60 blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] rounded-full bg-accent-100/40 blur-3xl"></div>
        <div className="absolute top-1/3 left-1/4 w-64 h-64 rounded-full bg-secondary-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-5">
              <i className="ri-fire-fill"></i>
              <span>水果植物视频 · 每日更新精选</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-4">
              向日葵视频
              <span className="block text-foreground-700 text-xl md:text-2xl lg:text-3xl font-normal mt-2">
                水果植物视频大全，高清免费在线观看
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-3">
              汇聚香蕉视频、西瓜视频免费专区、蜜桃视频、樱花视频等优质水果植物类视频平台资源，覆盖热门影视、综艺动漫、纪录片与生活短片，持续收录丰富内容，无需注册即可畅享不缓冲的高清流畅在线观看体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              本站为水果视频在线导航入口，每日更新精选专题，助你发现更多植物视频平台上的高分佳作与热门新片。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="flex items-center gap-1.5">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-movie-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-base md:text-lg font-bold text-foreground-900">每日更新</div>
                  <div className="text-xs text-foreground-500">专题持续上新</div>
                </div>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-base md:text-lg font-bold text-foreground-900">安全无毒</div>
                  <div className="text-xs text-foreground-500">绿色导航入口</div>
                </div>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-base md:text-lg font-bold text-foreground-900">高清流畅</div>
                  <div className="text-xs text-foreground-500">不缓冲不卡顿</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); scrollToAnchor('#carousel'); }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors cursor-pointer text-center whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-line mr-2"></i>探索精选专题
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); scrollToAnchor('#index'); }}
                className="w-full sm:w-auto px-8 py-3 bg-background-100 text-foreground-700 font-medium rounded-lg hover:bg-background-200 transition-colors cursor-pointer text-center whitespace-nowrap text-sm"
              >
                <i className="ri-compass-3-line mr-2"></i>查看主题索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Vibrant%20warm%20sunflower%20field%20with%20golden%20sunlight%20streaming%20through%20petals%2C%20soft%20bokeh%20background%20with%20floating%20leaves%20and%20citrus%20fruit%20elements%2C%20dreamy%20artistic%20illustration%20style%2C%20warm%20orange%20and%20green%20tones%2C%20modern%20flat%20design%20with%20subtle%20gradients%2C%20playful%20and%20youthful%20aesthetic%2C%20editorial%20composition&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                  alt="向日葵视频 - 水果植物视频平台主视觉"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.classList.add('bg-background-200');
                    }
                  }}
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center shadow-lg">
                <div className="text-center">
                  <i className="ri-play-fill text-background-50 text-2xl md:text-3xl"></i>
                </div>
              </div>
              <div className="absolute -top-3 -left-3 px-3 py-1.5 rounded-lg bg-background-50 shadow-sm border border-background-200">
                <span className="text-xs font-medium text-foreground-600 whitespace-nowrap">
                  <i className="ri-star-fill text-primary-500 mr-1"></i>精选推荐
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}